import React, { useEffect, useRef, useState } from "react";
import { Check, LoaderCircle, TriangleAlert } from "lucide-react";
import { BrandMark } from "./BrandMark";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [state, setState] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) {
      setState("error");
      return;
    }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const response = await fetch(`${API}/payments/status/${sessionId}`);
        const payload = await response.json();
        if (payload.payment_status === "paid") {
          setState("paid");
          return;
        }
        if (payload.payment_status === "failed" || payload.payment_status === "expired") {
          setState("error");
          return;
        }
      } catch (pollError) {
        console.debug("Payment status poll failed, retrying:", pollError);
      }
      if (attempts.current >= 8) {
        setState("pending");
        return;
      }
      timer = window.setTimeout(poll, 2000);
    };
    poll();
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="team-shell pay-shell" data-testid="payment-success-page">
      <div className="pay-card">
        <BrandMark compact />
        {state === "checking" && <div className="team-empty" data-testid="payment-checking"><LoaderCircle className="spin" size={18} /> Confirming your payment…</div>}
        {state === "paid" && (
          <div data-testid="payment-confirmed">
            <span className="success-mark"><Check size={19} /></span>
            <h1>Your date is reserved.</h1>
            <p>The deposit has been received and the Pop Social team has been notified. We’ll be in touch shortly with the final run of show.</p>
            <a className="button button-primary" href="/" data-testid="payment-home-link">Back to Pop Social</a>
          </div>
        )}
        {state === "pending" && (
          <div data-testid="payment-pending">
            <h1>Almost there…</h1>
            <p>Your payment is still processing. You’ll receive a Stripe receipt by email once it clears — no need to pay again.</p>
          </div>
        )}
        {state === "error" && (
          <div data-testid="payment-error">
            <span className="pay-warn"><TriangleAlert size={18} /></span>
            <h1>We couldn’t confirm that payment.</h1>
            <p>If your card was charged you’ll receive a Stripe receipt. Otherwise, reopen your payment link and try again.</p>
          </div>
        )}
      </div>
    </div>
  );
}
